<template>
  <TopBar @leading-icon-click="handleArrowClick">
    <template #leadingicon>
      <slot name="leadingicon">
        <ArrowLeftIcon class="h-6 w-6 cursor-pointer" />
      </slot>
    </template>

    <template #headline>
      <slot name="headline" />
    </template>

  </TopBar>
</template>
<script setup lang="ts">
import TopBar from './TopBar.vue';

import { ArrowLeftIcon } from '@heroicons/vue/24/outline';
import { useRouter, RouteLocationNamedRaw } from 'vue-router';

const props = defineProps<{
  backPage?: RouteLocationNamedRaw;
}>();

const handleArrowClick = () => {
  // Use real browser history when available, backPage is only a deep-link fallback
  if (window.history.state?.back != null) {
    router.back();
  } else if (props.backPage) {
    router.replace(props.backPage);
  }
}

const router = useRouter();
</script>